<mat-form-field class="allwidth">
    <input matInput placeholder="{{ showLabel ? ('COST_CENTER' | translate) : ''}}" [value]="selectedCostCenter?.Name" [disabled]="true" class="one">
      <i matSuffix *ngIf="ngControl?.control.enabled || enabled" class="glyphicon glyphicon-new-window link" (click)="selectCostCenter()"></i>
</mat-form-field>
<error *ngIf="ngControl" [control]="ngControl.control"></error>
